export default {
  label: {
    en: '{value, plural, one {# star} other {# stars}}',
  },
}
